module.exports = __webpack_public_path__ + "img/room-door.d26de70b.svg";